import e from "react";
import { componentName as n } from "../../../utils/bem/index.js";
import { Icon as a } from "../../general/Icon/Icon.js";
function r(e, n, a) {
  return n in e ? Object.defineProperty(e, n, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = a, e;
}
var t = {
  info: "info-square",
  success: "check",
  warning: "exclamation-circle",
  error: "exclamation-triangle"
};
function l(l) {
  var c,
    i = l.onClose,
    o = l.children,
    s = l.title,
    m = l.className,
    b = l.mode,
    u = void 0 === b ? "alert" : b,
    d = l.type,
    _ = void 0 === d ? "error" : d,
    f = l.shadow,
    p = t[_],
    E = n("banner", m, (r(c = {}, _, _), r(c, u, u), r(c, "shadow", f), c));
  return e.createElement("div", {
    className: E
  }, e.createElement("div", {
    className: "banner__inner-container"
  }, e.createElement(a, {
    regular: !0,
    fw: !0,
    name: p,
    className: "banner__icon"
  }), e.createElement("div", {
    className: "banner__text"
  }, s && e.createElement("span", {
    className: "banner__title"
  }, e.createElement("strong", null, s)), e.createElement("span", {
    className: "banner__children"
  }, o)), i && e.createElement("span", {
    className: "banner__close-button",
    onClick: i
  }, e.createElement(a, {
    name: "times",
    light: !0
  }))));
}
export { l as Banner };